/**
 * Los tres iconos del costado del editor, calcados del de Club Penguin.
 *
 * Van en SVG y no como imágenes por lo mismo que el resto de `icons.tsx`: pesan nada,
 * escalan sin borrarse y heredan el color del HUD. El look es el de la referencia —
 * trazo oscuro y grueso, relleno plano, una sola luz— que es lo que hace que un dibujo
 * de veinte líneas se lea como un icono de juego y no como un pictograma de barra de
 * herramientas.
 *
 * Todos dibujan sobre un lienzo de 48x48 y sin `fill` propio en el trazo, así que el CSS
 * puede apagarlos (el botón deshabilitado) sin tocar esto.
 */

const TRAZO = "#14304d";

/**
 * El iglú con la flecha girando encima: cambiar el cuarto.
 *
 * La cúpula va en azul claro y no en blanco: el disco del botón ya es casi blanco, y la
 * primera versión —cúpula blanca sobre disco blanco— se leía como una flecha suelta.
 */
export function IconIglu() {
  return (
    <svg viewBox="0 0 48 48" width="38" height="38" aria-hidden="true">
      {/* la flecha, detrás de la cúpula para que parezca rodearla */}
      <path
        d="M7 20a17 13 0 0 1 31-4"
        fill="none"
        stroke="#f5b929"
        strokeWidth="6"
        strokeLinecap="round"
      />
      <path d="M43 18l-9 2 3-8z" fill="#f5b929" />
      {/* la cúpula, apoyada en su línea de suelo */}
      <path
        d="M8 40a16 14 0 0 1 32 0z"
        fill="#dbeaf7"
        stroke={TRAZO}
        strokeWidth="2.6"
        strokeLinejoin="round"
      />
      <path d="M7 40h34" stroke={TRAZO} strokeWidth="2.6" strokeLinecap="round" />
      {/* el túnel de entrada */}
      <path
        d="M19 40v-7a5 5 0 0 1 10 0v7z"
        fill="#1d4b78"
        stroke={TRAZO}
        strokeWidth="2.4"
        strokeLinejoin="round"
      />
      {/* las juntas del hielo: sin ellas la cúpula es una media luna lisa */}
      <path
        d="M14 32l5-3M34 32l-5-3M24 26v-4"
        stroke={TRAZO}
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
}

/** La fachada con toldo: la tienda de muebles. */
export function IconTienda() {
  return (
    <svg viewBox="0 0 48 48" width="38" height="38" aria-hidden="true">
      <rect x="10" y="20" width="28" height="20" rx="1.5" fill="#2f7d5c" stroke={TRAZO} strokeWidth="2.5" />
      {/* el toldo, a rayas como el de la referencia */}
      <path
        d="M7 20l3-6h28l3 6z"
        fill="#3f9a72"
        stroke={TRAZO}
        strokeWidth="2.5"
        strokeLinejoin="round"
      />
      <path
        d="M15 14l-2 6M22 14l-1 6M29 14l1 6M36 14l2 6"
        stroke="#d9f0e4"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      {/* puerta y ventanas */}
      <rect x="20" y="28" width="8" height="12" fill="#d9f0e4" stroke={TRAZO} strokeWidth="2" />
      <rect x="12" y="25" width="6" height="6" fill="#9fd8c0" stroke={TRAZO} strokeWidth="1.8" />
      <rect x="30" y="25" width="6" height="6" fill="#9fd8c0" stroke={TRAZO} strokeWidth="1.8" />
    </svg>
  );
}

/** La caja abierta con la flecha: guardar lo que está puesto. */
export function IconCaja() {
  return (
    <svg viewBox="0 0 48 48" width="38" height="38" aria-hidden="true">
      {/* las solapas, abiertas hacia afuera */}
      <path
        d="M12 22l-5-5 9-3 4 5z"
        fill="#dbb887"
        stroke={TRAZO}
        strokeWidth="2.2"
        strokeLinejoin="round"
      />
      <path
        d="M36 22l5-5-9-3-4 5z"
        fill="#dbb887"
        stroke={TRAZO}
        strokeWidth="2.2"
        strokeLinejoin="round"
      />
      <rect x="12" y="22" width="24" height="18" rx="1.5" fill="#c8a06a" stroke={TRAZO} strokeWidth="2.5" />
      <path d="M24 22v18" stroke={TRAZO} strokeWidth="1.6" opacity="0.5" />
      {/* La flecha sale de la caja, como en la referencia: lo guardado vuelve a la barra. */}
      <path d="M24 20v-8" stroke="#e3453c" strokeWidth="4" strokeLinecap="round" />
      <path d="M24 6l-5 7h10z" fill="#e3453c" />
    </svg>
  );
}
